import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  StaticProvider
} from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { PriceInformation } from 'src/app/api/owcc/models';
import { LazyHostComponent } from 'src/app/core/lazy-host/lazy-host.component';
import { LazyComponentId } from 'src/app/core/services/lazy-components/lazy-components-registry';
import {
  selectConfigurationVehiclePriceInformation,
  selectUsePriceDisplayComponent
} from 'src/app/store/common/common.selectors';
import { discountedOrConfigurationPrice } from 'src/app/utils/models/price-information';

import { FootnoteHintRRPComponent } from '../../footnotes/footnote-hint-rrp/footnote-hint-rrp.component';
import { FootnoteHint } from '../../footnotes/footnote-hint/footnote-hint.enum';
import { FormattedPricePipe } from '../../pipes/price/formatted-price.pipe';
import { OutputEmitter } from '../output-emitter';
import { OUTPUT_EMITTER, PRICE_DISPLAY_PARAMS } from '../price-display.component';
import { PriceDisplayParams, PriceDisplayStatus } from '../price-display.interface';

// TODO: Fix with MBCC-2652
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'cc-price-display-container',
  templateUrl: './price-display-container.component.html',
  imports: [CommonModule, LazyHostComponent, FormattedPricePipe, LetDirective, FootnoteHintRRPComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './price-display-container.component.scss'
})
export class PriceDisplayContainerComponent implements OnChanges {
  @Input() public readonly params!: PriceDisplayParams;

  @Output('priceDisplayEmitter') public readonly priceDisplayEmitter = new OutputEmitter<PriceDisplayStatus>();

  public priceDisplayDataProvider$!: Observable<StaticProvider[]>;
  public priceDisplayComponent = LazyComponentId.PriceDisplay;
  public footnoteHint = FootnoteHint;

  public discountedOrConfigurationPrice = discountedOrConfigurationPrice;

  public usePriceDisplayComponent$ = this.store.select(selectUsePriceDisplayComponent);

  public vehiclePriceInformation$: Observable<PriceInformation> = this.store.pipe(
    selectConfigurationVehiclePriceInformation
  );
  public isWithinModal!: boolean;

  public constructor(private readonly store: Store) {}

  public ngOnChanges({ params }: SimpleChanges): void {
    if (params) {
      this.setProviderObservale(params.currentValue as PriceDisplayParams);
    }
  }

  private setProviderObservale(params: PriceDisplayParams): void {
    if (this.priceDisplayDataProvider$) {
      return;
    }

    this.priceDisplayDataProvider$ = this.createPriceDisplayDataProviders({
      ...params
    });
  }

  private createPriceDisplayDataProviders(priceDisplayParams: PriceDisplayParams): Observable<StaticProvider[]> {
    return of([
      {
        provide: PRICE_DISPLAY_PARAMS,
        useValue: priceDisplayParams
      } as StaticProvider,
      {
        provide: OUTPUT_EMITTER,
        useFactory: () => this.priceDisplayEmitter
      } as StaticProvider
    ] as StaticProvider[]);
  }
}
